import { useEffect } from 'react';
import Lenis from 'lenis';

export function useLenis(options) {
  useEffect(() => {
    const lenis = new Lenis(options);
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, [options]);
}
